import { render, staticRenderFns } from "./Page_2.vue?vue&type=template&id=db8380ec&scoped=true&"
import script from "./Page_2.vue?vue&type=script&lang=js&"
export * from "./Page_2.vue?vue&type=script&lang=js&"
import style0 from "./Page_2.vue?vue&type=style&index=0&id=db8380ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8380ec",
  null
  
)

export default component.exports